import { NavLink }      from 'react-router-dom';
import IconsDashboard   from 'assets/icons/Dashboard.svg';
// import IconsCalendar    from 'assets/icons/Calendar.svg';
// import IconsTeleconsult from 'assets/icons/Teleconsult.svg';
import IconsEB from "assets/icons/Employee Benefits.svg";
import IconsLogs from "assets/icons/Logs.svg";
import IconsTelc from "assets/icons/Teleconsult.svg";
import IconsSms from "assets/icons/Sms.svg";
import IconsMeal from "assets/icons/Meal.svg";
import IconsMedicine from "assets/icons/medicineIcon.svg";
import IconsWallet from "assets/icons/Wallet.svg";

import AuthService      from 'services/auth.service';
import NotificationBatch                      from './NotificationBatch';

const currentUser = AuthService.getCurrentUser();
const currentAssistant = AuthService.getCurrentAssistant();
const practiceLocation = AuthService.getPracticeLocation();
const isBookDocEmployees = currentUser?.is_bookdoc_nutritionist || currentUser?.is_bookdoc_mental_health_coach;

var parentNavbarList    = [];
var childNavbarList     = [];

if (currentUser && currentUser.eb_enabled) {
  parentNavbarList.push({ title: 'Employee Benefits',   image: IconsEB,           href: '/eb'  });

  childNavbarList.push({ parent: 'Employee Benefits',  title: 'Pre-Registration',      href: '/eb/preregistration' });
  childNavbarList.push({ parent: 'Employee Benefits',  title: 'Claims',                href: '/eb/claims' });
  childNavbarList.push({ parent: 'Employee Benefits',  title: 'Guarantee Letter',      href: '/eb/guarantee_letter' });
}

// var parentNavbarList    = [
//   // { title: 'Dashboard',           image: IconsDashboard,    href: '/eb'  },
//   // { title: 'Calendar',            image: IconsCalendar,     href: '/eb/appointments'  },
//   ,
// ];

// var childNavbarList     = [
//   // { parent: 'Calendar',           title: 'Availability',          href: '/eb/availability' },
//   // { parent: 'Calendar',           title: 'Availability/Time Off', href: null },
// ];

if (currentAssistant && currentUser && currentUser.user_type === 'assistant') {
  parentNavbarList = [
    { title: 'Doctor List',     image: IconsEB,   href: '/eb/assistant/dashboard' },
    { title: 'View All Claims', image: IconsLogs, href: '/eb/assistant/claims' }
  ]

  childNavbarList = [];
} else if (currentAssistant && currentUser && currentUser.user_type === 'doctor') {
  parentNavbarList.push({ title: 'Doctor List',     image: IconsDashboard,      href: '/eb/assistant/dashboard' });
  childNavbarList.push({ parent: 'Doctor List',     title: "Doctor's Profile",  href: '/eb/profile' });
  parentNavbarList.push({ title: 'View All Claims', image: IconsLogs,           href: '/eb/assistant/claims' });
}

if (currentUser && currentUser.user_type !== 'assistant' && currentAssistant === null) {
  if(currentUser.enable_chat){
    parentNavbarList.push({ title: 'Teleconsultation', image: IconsTelc,        href: '/eb/teleconsult'  });
  }
  if (!isBookDocEmployees) {
    parentNavbarList.push(
      { title: "Logs", image: IconsLogs }, 
      { title: "My Wallet", image: IconsWallet,href: "/eb/wallet" }
    );

    childNavbarList.push({
      parent: "Logs",
      title: "Audits Logs",
      href: "/eb/audit_logs",
    });

    childNavbarList.push({
      parent: "Logs",
      title: "Referral Logs",
      href: "/eb/referral_logs",
    });
  }
}

if (practiceLocation && practiceLocation.sms_enabled) {
  parentNavbarList.push({
    title: "Sms Reminder",
    image: IconsSms,
    href: "/eb/sms_reminder",
  });
  childNavbarList.push({
    parent: "Sms Reminder",
    title: "Sms Reminder Logs",
    href: "/eb/sms_reminder_logs",
  });
}

if (currentUser && currentUser?.is_bookdoc_nutritionist) {
  parentNavbarList.push({
    title: "Meals",
    image: IconsMeal,
    href: "/eb/meals",
  });
}

if(currentUser && currentUser.user_type === 'doctor' && currentUser.e_prescription_enabled){
  parentNavbarList.push({
    title: "Medicine Delivery",
    image: IconsMedicine,
    href: "/eb/prescriptions",
  });
} 

const toggleMobileDropdown = (props) => {
  props.triggerDropdown && props.triggerDropdown();
}

export const SidebarLinks = (props) => {
  const navbarElements = parentNavbarList.map((hash, index) => {
    var hasChildren = childNavbarList.filter(childHash => {
      return childHash.parent === hash.title;
    });

    const childElements = hasChildren.map((childHash, childIndex) => {
      var childNavElement =
        <nav key={ 'sidebar-child-link-' + childHash.title } className="sidebar-link-child-item">
          {  childHash.title }
        </nav>

      if (childHash.href) {
        return (
          <NavLink key={ 'sidebar-child-link-link-' + childHash.title } end={ true } className={({ isActive }) => "" + (isActive ? "is-active" : "") } to={ childHash.href } onClick={() => toggleMobileDropdown(props) } >
            { childNavElement }
          </NavLink>
        );
      } else {
        return childNavElement;
      }
    });

    var navElement =
      <nav key={ 'sidebar-link-' + hash.title } className="sidebar-link-list-item">
        <img src={ hash.image } alt={ hash.title }/>
        { hash.title }
        {hash.title === 'Teleconsultation' &&
          <NotificationBatch />
        }
      </nav>

    let displayed;

    if (hash.href) {
      displayed =
        <NavLink end={ true } className={({ isActive }) => "" + (isActive ? "is-active" : "") } to={ hash.href } onClick={() => toggleMobileDropdown(props) } >
          { navElement }
        </NavLink>
    } else {
      displayed = navElement
    }

    return (
      <div key={ 'sidebar-link-group-' + hash.title }>
        { displayed }
        { childElements }
      </div>
    );
  });

  return navbarElements;
}